import { displayNotification, sendAPIRequest } from "helpers";

export const getUmbrellaConcepts = async (countryId = '', languageId = '', competencyAreaId = '') => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/?country_id=${countryId}&language_id=${languageId}&competency_area_id=${competencyAreaId}`);
        const res = await ret.json();
        if (res.success) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getConcepts = async (ids) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-concepts/`, 'POST', {
            ids: ids.join(',')
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getConceptUmbrellaConcepts = async (id = null) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-concept-um-concepts/${id}`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const getRawTextConcepts = async (id = null) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/get-raw-text-concepts/${id}`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}

export const deleteUmbrellaConcepts = async (ids = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/delete/`, 'DELETE', {
            data: ids
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully deleted [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to delete [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to delete [F]');
        return { success: false, data: [] };
    }
}

export const editUmbrellaConcept = async (body = {}, notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/handle-editing`, 'PUT', body);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully updated concept [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to update concept [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to update concept [F]');
        return { success: false, data: [] };
    }
}

export const mergeUmbrellaConcepts = async (ids = '', umbrella_concept = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/merge/`, 'POST', {
            data: ids,
            umbrella_concept: umbrella_concept
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully merged umbrella concepts [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to merged umbrella concepts [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to merged umbrella concepts [F]');
        return { success: false, data: [] };
    }
}

export const tagUmbrellaConcepts = async (ids = '', tag = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/handle-taging/`, 'POST', {
            ids: ids,
            tag_type: tag
        });
        const res = await ret.json();
        if (res.success && res.status === 200) {
            notification && displayNotification('success', 'Successfully merged umbrella concepts [B]');
            return { success: true, data: res.data };
        } else {
            notification && displayNotification('error', 'Failed to merged umbrella concepts [B]');
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        notification && displayNotification('error', 'Failed to merged umbrella concepts [F]');
        return { success: false, data: [] };
    }
}

export const checkSimilarityIndex = async (countryId = '', languageId = '', competencyAreaId = '', text = '', notification = true) => {
    try {
        const ret = await sendAPIRequest(`/api/qualitative-cleaning/check-similarity/?country_id=${countryId}&language_id=${languageId}&competency_area=${competencyAreaId}&text=${text}`);
        const res = await ret.json();
        if (res.success && res.status === 200) {
            return { success: true, data: res.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (e) {
        console.log(e);
        return { success: false, data: [] };
    }
}